import { LitElement, html, css } from "lit-element";

// language=CSS
export const InputTextareaStyle = css`
	input-textarea {
		display: inline-block;

		width: 100%;
	}

	input-textarea > textarea::-webkit-input-placeholder {
		color: transparent;
	}

	input-textarea > textarea::-moz-placeholder {
		color: transparent;
	}

	input-textarea > textarea:-ms-input-placeholder {
		color: transparent;
	}

	input-textarea > textarea::-ms-input-placeholder {
		color: transparent;
	}

	input-textarea > textarea {
		font-size: 1em;
		font-weight: 300;
		min-height: 300px;
		color: var(--app-primary);
		box-sizing: border-box;
		width: 100%;
		border: 1px solid var(--app-lightgrey);
		margin: 10px 0 8px;
		padding: 20px;
		border-radius: 5px;
		outline: none;
		background-color: transparent;

		resize: none;
	}

	input-textarea > label {
		font-size: 14px;
		display: block;
		opacity: 1;
	}

	input-textarea > textarea[aria-invalid="true"] {
		box-shadow: 0 0 3px red;
	}
`;

// language=CSS
export const InputTextareaHostStyle = css`
	:host {
		display: inline-block;

		width: 100%;
	}

	:host > textarea::-webkit-input-placeholder {
		color: transparent;
	}

	:host > textarea::-moz-placeholder {
		color: transparent;
	}

	:host > textarea:-ms-input-placeholder {
		color: transparent;
	}

	:host > textarea::-ms-input-placeholder {
		color: transparent;
	}

	:host > textarea {
		font-size: 1em;
		font-weight: 300;
		min-height: var(--input-textarea-height, 300px);
		color: var(--app-primary);
		box-sizing: border-box;
		width: 100%;
		border: 1px solid var(--app-lightgrey);
		margin: 10px 0 8px;
		padding: 20px;
		border-radius: 5px;
		outline: none;
		background-color: transparent;

		resize: none;
	}

	:host > label {
		font-size: 14px;
		display: block;
		opacity: 1;
	}

	:host > textarea[aria-invalid="true"] {
		box-shadow: 0 0 3px red;
	}
`;

export class InputTextarea extends LitElement {
	static get properties() {
		return {
			name: { type: String },
			label: { type: String },
			value: { type: String },
			cast: { type: String },
			required: { type: Boolean },
			disabled: { type: Boolean }
		};
	}

	static get styles() {
		return InputTextareaHostStyle;
	}

	render() {
		return html`
			<label>${this.label}</label>
			<textarea
				data-cast="${this.cast ? this.cast : "text"}"
				name="${this.name}"
				?readonly="${this.readonly}"
				?disabled="${this.disabled}"
			>
${this.value}</textarea
			>
		`;
	}
}

customElements.define("input-textarea", InputTextarea);
